import React from 'react';
import { CircularProgressbar } from 'react-circular-progressbar';
import moment from 'moment';
import PropTypes from 'prop-types';
import useResponsive from 'hooks/useResponsive';
import CalculateScoreColor from 'components/utils/scoreHelpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { formatNumberWithCommas } from '../../helpers';

import {
  Row,
  Column,
  Thumbnail,
  ScoreWrapper,
  MobileRow,
  MobileColumn,
  MobileText,
  MobileThumb,
  MobileScore,
  Error,
  CRBreakdown,
  AdditionalInfo,
} from '../styles';

const VehicleItem = ({
  item, customRef, gridView, setShowImageCarousel, highlight, setImageArray,
}) => {
  const { isLargeView } = useResponsive();

  if (!item) {
    return <Row ref={customRef} highlight={highlight} gridView={gridView}><Error>There was a problem loading this unit</Error></Row>;
  }

  if (isLargeView) {
    return (
      <Row ref={customRef} highlight={highlight} gridView={gridView}>
        <Column gridView={gridView}>
          <Thumbnail
            onClick={() => {
              if (!item.pictureURLs[0]) {
                return;
              }
              setImageArray(item.pictureURLs);
              setShowImageCarousel(true);
            }}
            src={
                Array.isArray(item?.pictureURLs) && item.pictureURLs[0]?.thumbURL
                  ? item.pictureURLs[0].thumbURL
                  : 'https://www.npauctions.com/images/noimage.jpg'
            }
          />
        </Column>
        <Column gridView={gridView}>
          <ScoreWrapper color={CalculateScoreColor(item.score).color} gridView={gridView}>
            <CircularProgressbar value={item.score} text={item.score} />
          </ScoreWrapper>
        </Column>
        <Column gridView={gridView}>
          <CRBreakdown>{item?.inspectionHeaders}</CRBreakdown>
        </Column>
        <Column gridView={gridView}>
          {item.mileage}
        </Column>
        <Column gridView={gridView}>
          $
          {formatNumberWithCommas(item.saleAmount)}
        </Column>
        <Column gridView={gridView}>{moment(item.saleDate).format('MM/DD/YYYY').toString()}</Column>
        <Column gridView={gridView}>{item.location}</Column>
        <Column gridView={gridView}>{item.color}</Column>
      </Row>
    );
  }

  return (
    <MobileRow>
      <MobileThumb>
        <Thumbnail
          onClick={() => {
            if (!item.pictureURLs[0]) {
              return;
            }
            setShowImageCarousel(true);
          }}
          src={item.pictureURLs[0] ? item.pictureURLs[0].url : 'https://www.npauctions.com/images/noimage.jpg'}
        />
      </MobileThumb>
      <MobileColumn>
        <MobileText>
          <span>
            Mi/Hr:
          </span>
          {' '}
          {item.mileage !== 'TMU' ? item.mileage : 'TMU'}

        </MobileText>
        <MobileText>
          <span>Location:</span>
          {' '}
          {item.location}
        </MobileText>
        <MobileText>
          <span>Sale date:</span>
          {' '}
          {moment(item.saleDate).format('MM/DD/YYYY').toString()}
        </MobileText>
        <MobileText>
          <span>Color:</span>
          {' '}
          {item.color}
        </MobileText>
        <MobileText>
          <span>Sale price:</span>
          {' '}
          {`$${formatNumberWithCommas(item.saleAmount)}`}
        </MobileText>
        <MobileText>
          {item?.inspectionHeaders}
        </MobileText>
        <AdditionalInfo>
          <MobileText>
            <strong>Key:</strong>
          </MobileText>
          <MobileText indent>
            <strong>EM</strong>
            - Engine Mechanical
          </MobileText>
          <MobileText indent>
            <strong>FR</strong>
            - Frame
          </MobileText>
          <MobileText indent>
            <strong>TR</strong>
            - Transmission
          </MobileText>
        </AdditionalInfo>
      </MobileColumn>
      <MobileScore>
        <ScoreWrapper color={CalculateScoreColor(item.score).color} gridView={false}>
          <CircularProgressbar value={item.score} text={item.score} />
        </ScoreWrapper>
      </MobileScore>
    </MobileRow>
  );
};

VehicleItem.propTypes = {
  item: PropTypes.object.isRequired,
  customRef: PropTypes.object.isRequired,
  gridView: PropTypes.bool,
  setShowImageCarousel: PropTypes.func.isRequired,
  setImageArray: PropTypes.func.isRequired,
  highlight: PropTypes.bool,
};

VehicleItem.defaultProps = {
  highlight: false,
  gridView: false,
};

export default VehicleItem;
